import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";

import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import { getStripePublishableKey } from "@/main/services/utils";
import { quoteApi } from "@/main/api";
import { SpinnerLoading } from "@/main/components/shared/styles";

import * as S from "./styles";

interface IModalStripeProps {
	guidQuote: string;
	isOpenModal: boolean;
	setIsOpenModal: (isOpenModal: boolean) => void;
	isLoadingPendingPayment: boolean;
	isLoadingOpenModalStripe: boolean;
	setIsLoadingPendingPayment: React.Dispatch<React.SetStateAction<boolean>>;
	setClientSecret: (clientSecret: string) => void;
	setIsPaymentPending: (isPaymentPending: boolean) => void;
	clientSecret: string;
	changeQuotePaymentPending: () => void;
}

const stripePromise = loadStripe(getStripePublishableKey());
function ModalStripe({
	isLoadingOpenModalStripe,
	isLoadingPendingPayment,
	changeQuotePaymentPending,
}: IModalStripeProps) {
	function handleClose(event: React.MouseEvent<HTMLButtonElement>) {
		event.preventDefault();
		event.stopPropagation();

		changeQuotePaymentPending();
	}

	return (
		<S.Container>
			<S.AreaCloseIcon>
				<IconButton disabled={isLoadingPendingPayment} onClick={handleClose}>
					<Close />
				</IconButton>
			</S.AreaCloseIcon>

			{isLoadingPendingPayment || isLoadingOpenModalStripe ? (
				<S.AreaLoading>
					<SpinnerLoading />
				</S.AreaLoading>
			) : (
				<div id="checkout">
					<EmbeddedCheckout />
				</div>
			)}
		</S.Container>
	);
}

type TYPES_IGNORE = "isLoadingPendingPayment" | "changeQuotePaymentPending" | "setIsLoadingPendingPayment";
function WrapperModalStripe(props: Omit<IModalStripeProps, TYPES_IGNORE>) {
	const [isLoadingPendingPayment, setIsLoadingPendingPayment] = useState(false);

	function changeQuotePaymentPending() {
		setIsLoadingPendingPayment(true);
		props.setClientSecret("");
		quoteApi
			.updatePaymentPending(String(props.guidQuote))
			.then(() => {
				props.setIsPaymentPending(false);
			})
			.finally(() => {
				setIsLoadingPendingPayment(false);
				props.setIsOpenModal(false);
			});
	}

	function onCompleteStripe() {
		// NOTATION: Check to use the onCompleteStripe
	}

	function customSetIsOpenModal(_value: boolean) {
		changeQuotePaymentPending();
	}

	const customProps: IModalStripeProps = {
		...props,
		isLoadingPendingPayment,
		setIsLoadingPendingPayment,
		changeQuotePaymentPending,
	};
	return (
		<KogModalFadeComponent isInModal open={props.isOpenModal} setOpen={customSetIsOpenModal}>
			<EmbeddedCheckoutProvider
				stripe={stripePromise}
				options={{
					clientSecret: props.clientSecret,
					onComplete: onCompleteStripe,
				}}
			>
				<ModalStripe {...customProps} />
			</EmbeddedCheckoutProvider>
		</KogModalFadeComponent>
	);
}
export default WrapperModalStripe;
